/// <reference path="../typings.d.ts" />
import { FormControl, Validators, FormGroup } from '@angular/forms';

export class AppValidators {


	static email(c: FormControl): { [key: string]: boolean } {
		if (Helper.isPresent(Validators.required(c))) return null;
		if (!AppValidators.isEmail(c.value)) {
			return { invalidEmail: true }
		}
	}

	static date(c: FormControl): { [key: string]: boolean } {
		if (Helper.isPresent(Validators.required(c))) return null;
		if (!AppValidators.isDate(c.value)) {
			return { invalidDate: true }
		}
	}

	static number(c: FormControl): { [key: string]: boolean } {
		if (Helper.isPresent(Validators.required(c))) return null;
		if (!AppValidators.isNumber(c.value)) {
			return { invalidNumber: true }
		}
	}

	static isEmail(email: string) {
		var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
		return email.toLowerCase().match(emailRegex)
	}

	static isDate(date: string) {
		var dateRegex = /^(?:(0[1-9]|1[012])[\/.](0[1-9]|[12][0-9]|3[01])[\/.](19|20)[0-9]{2})$/;
		return date.match(dateRegex)
	}

	static isNumber(intStr: string) {
		var intRegex = /^0$|^-?[1-9]\d*(\.\d+)?$/;
		return intStr.match(intRegex)
	}
}

class Helper {
	static isPresent(obj: any): boolean {
		return obj != null;
   }
}

export function controlErrors(f: FormGroup, callback: any) {
	var c: any;
	var name: any;
	Object.keys(f.controls).forEach(name => {
		c = f.controls[name];
		if (!c.valid) {
			if (c.hasError('invalidEmail')) {
				callback(c, name + ' has invalid email address.');
			} else if (c.hasError('required')) {
				callback(c, name + ' is required.');
			} else if (c.hasError('minlength')) {
				let v = c.errors['minlength'].requiredLength;
				callback(c, `${name} min length is ${v}.`);
			} else if (c.hasError('invalidNumber')) {
				callback(c, name + ' has invalid number, must be numeric (ex. -23, 23 or 23.10)');
			} else if (c.hasError('invalidDate')) {
				callback(c, name + ' has invalid date, must be on format of MM/DD/YYYY (ex. 02/12/2016).');
			} else if (c.hasError('maxlength')) {
				let v = c.errors['maxlength'].requiredLength;
				callback(c, `${name} max length is ${v}.`);
			}
		}
	});
}
